<template>
<div id="app" class="site container hfeed">
  <HeadNav selectedLanguage="en" page="disclaimer" />

  <div id="content" class="site-content">
    <article id="article" >
      <section id="disclaimerpage">

        <!-- 免责声明主要内容 -->
        <div class="disclaimer-hero-section">
          <div class="disclaimer-container">
            <!-- 主标题 -->
            <h1 class="main-title">
              Disclaimer
            </h1>

            <!-- 重要通知 -->
            <div class="important-notice">
              <h2 class="section-title">Important Notice:</h2>
            </div>

            <!-- 免责声明内容 -->
            <div class="disclaimer-content">
              <div class="disclaimer-item">
                <h3 class="disclaimer-subtitle">Not Affiliated with WhatsApp or Meta</h3>
                <p>
                  Our website and the GB WhatsApp APKs shared here are not affiliated, endorsed, or connected with WhatsApp, Meta, or any of their official services.
                </p>
              </div>

              <div class="disclaimer-item">
                <h3 class="disclaimer-subtitle">Third-Party APKs</h3>
                <p>
                  The APK files provided are from third-party sources. We do not guarantee their security, authenticity, or functionality. Users should download and use them at their own risk.
                </p>
              </div>

              <div class="disclaimer-item">
                <h3 class="disclaimer-subtitle">Educational Purposes Only</h3>
                <p>
                  All content, guides, and APKs are shared for educational and informational purposes only. We do not encourage piracy, illegal distribution, or any activity that violates WhatsApp's terms of service.
                </p>
              </div>

              <div class="disclaimer-item">
                <h3 class="disclaimer-subtitle">Use at Your Own Risk</h3>
                <p>
                  By using GB WhatsApp or other modded apps, you understand that your account or device could be at risk. We are not responsible for any data loss, account bans, or device issues resulting from the use of these apps.
                </p>
              </div>

              <div class="disclaimer-item">
                <h3 class="disclaimer-subtitle">Recommendation</h3>
                <p>
                  Always backup your WhatsApp data and use caution when installing APKs from third-party sources. For official features and full security, we recommend using the official WhatsApp app.
                </p>
              </div>
            </div>

          </div>
        </div>

      </section>
    </article>
  </div>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
  },
  methods: {
    goHome() {
      this.$router.push({
        name: 'en-gb'
      });
    },
  },
};
</script>

<style scoped>
/* 免责声明页面主要样式 */
.disclaimer-hero-section {
  background: white;
  border-radius: 12px;
  padding: 40px;
  margin: 20px 0;
  border: 2px solid #1EC0B9;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.disclaimer-container {
  max-width: 800px;
  margin: 0 auto;
}

/* 主标题样式 */
.main-title {
  font-size: 2.5em;
  font-weight: bold;
  color: #1EC0B9;
  margin-bottom: 30px;
  line-height: 1.3;
  text-align: center;
}

/* 重要通知样式 */
.important-notice {
  margin-bottom: 30px;
  text-align: center;
}

.section-title {
  color: #1EC0B9;
  font-size: 1.8em;
  font-weight: 700;
  margin-bottom: 20px;
  border-bottom: 3px solid #1EC0B9;
  padding-bottom: 10px;
  text-align: center;
}

/* 免责声明内容样式 */
.disclaimer-content {
  display: grid;
  gap: 25px;
  margin-bottom: 40px;
}

.disclaimer-item {
  background: white;
  padding: 25px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #1EC0B9;
  transition: all 0.3s ease;
}

.disclaimer-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
}

.disclaimer-subtitle {
  color: #1EC0B9;
  font-size: 1.3em;
  font-weight: 600;
  margin-bottom: 15px;
  line-height: 1.4;
}

.disclaimer-item p {
  color: #333;
  font-size: 1.1em;
  line-height: 1.6;
  margin: 0;
}

/* 返回首页按钮样式 */
.back-home-section {
  text-align: center;
  margin-top: 40px;
}

.back-home-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #1EC0B9;
  color: white;
  text-decoration: none;
  padding: 15px 30px;
  border-radius: 25px;
  font-weight: bold;
  font-size: 16px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(30, 192, 185, 0.3);
  border: none;
  cursor: pointer;
  min-width: 200px;
  justify-content: center;
}

.back-home-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(30, 192, 185, 0.4);
  background: #1EC0B9;
}

.back-home-btn:active {
  transform: translateY(0);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .disclaimer-hero-section {
    padding: 25px 20px;
    margin: 10px;
    border-radius: 8px;
  }

  .main-title {
    font-size: 2em;
    margin-bottom: 25px;
  }

  .section-title {
    font-size: 1.5em;
  }

  .disclaimer-item {
    padding: 20px;
  }

  .disclaimer-subtitle {
    font-size: 1.2em;
  }

  .disclaimer-item p {
    font-size: 1em;
  }

  .back-home-btn {
    min-width: 180px;
    padding: 12px 25px;
    font-size: 14px;
  }
}
</style>

